import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import * as actions from '../auth/modules/auth'
import get from 'lodash/get'

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  token: state.auth.token,
  isRehydrated: get(state,'auth._persist.rehydrated'),
})

const mapDispatchToProps = dispatch => ({
  authActions: bindActionCreators(actions, dispatch),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)
